import React, {Fragment} from 'react';
import AbstractComponent from '../../AbstractComponent'; 
import Button from '../button/ButtonCol';
import Preload from '../preload/PreloadContent';

import AutenticarService from '../../../service/AutenticarService';

import { route } from '../../../helper/Route';
import config from '../../../Config';
   
class SideNav extends AbstractComponent { 
    route(item) {
        if(AutenticarService.getIdEmpresa() === 0) {
            alert('Selecione uma empresa');
            return ;
        }
        
        this.props.route(route(item.icone, item.nome, item.link));
    }

    subMenu(item, i) {
        return (
            <div
                key={i}         
                className="collapse"            
                id={"collapse" + item.nome}
                aria-labelledby="headingOne" 
                data-parent="#sidenavAccordion"
                aria-expanded={false}
            >
                <nav className="sb-sidenav-menu-nested nav">
                    {   
                        item.submenu.map((submenu, submenuI ) => {
                            return (
                                <a 
                                    key={submenuI}
                                    className="nav-link" 
                                    onClick={() => this.route(submenu)}
                                >
                                    {submenu.descricao}
                                </a>                                   
                            )
                        })
                    }                    
                </nav>
            </div>
        )
    }

    showIcon(img) {
        const ext = img.split('.').pop();

        if(ext === 'svg') {            
            return (
                <img src={config.urlImgBase + img} alt="icone" width='20px' height='20px' style={{marginRight: '5px'}}/>                
            )
        }

        return (
            <i className={"menu " + img} />
        );
    }

    menu(item, index) {
        if(item.tem_filho === 0) {
            return (
                <a 
                    key={index} 
                    className="nav-link" 
                    onClick={() => this.route(item)}
                >
                    <div className="sb-nav-link-icon">
                        {this.showIcon(item.icone)}
                    </div>

                    {item.descricao}
                </a>
            );
        }

        return (
            <Fragment key={index}>
                <a                     
                    className="nav-link collapse collapsed"
                    data-toggle="collapse"
                    data-target={'#collapse' + item.nome}
                    aria-expanded={false}
                    aria-controls={'collapse' + item.nome}
                    
                >
                    <div className="sb-nav-link-icon">
                        <i className={item.icone} />                                            
                    </div>

                    {item.descricao}
                    
                    <div className="sb-sidenav-collapse-arrow">
                        <i className="fas fa-angle-down" />
                    </div>                
                </a>      
                
                { this.subMenu(item, index) }
            </Fragment>
        )
    }   

    showComponent() {
        if(this.props.preload) {
            return (
                <Preload show={true} />
            );
        }

        return (            
            <Fragment>
                <div className="sb-sidenav-menu">
                    <div className="nav">
                        {this.props.menu.map((item, i ) => {
                            return(
                                this.menu(item, i)
                            );
                        })}                                                        
                    </div>
                </div>

                <div className="sb-sidenav-footer" style={{minHeight: '72px'}}>
                    <div className="col-md-12
                                    col-sm-12
                                    col-lg-12
                                    col-xs-12
                                    small">                        
                        Registrado para
                    </div>

                    <div 
                        className="col-md-8
                                    col-sm-8
                                    col-lg-8
                                    col-xs-8"
                        style={{paddingRight: '0px'}}
                    >
                        {this.props.usuario.empresa.nome} 
                    </div>

                    {
                        !this.props.preload && this.props.changeEmpresa &&
                        <Button
                            md={4} 
                            xs={4} 
                            sm={4} 
                            lg={4}
                            className="btn-changeEmpresa"
                            background={2}
                            style={{paddingLeft: '0px', lineHeight: '30px'}}
                            marginTop={'-8px'}
                            showSpan={false}
                            type="button" 
                            onClick={() => this.props.onClick()}
                        >                                
                            Mudar                                
                        </Button>
                    }
                </div>                    
            </Fragment>            
        );
    }

    render() {
        return (
            <div id="layoutSidenav_nav">
                <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                    {this.showComponent()}
                </nav>
            </div>
        )
    }
}

export default SideNav;